import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { View } from 'react-native';
import { PresentCommunityScreenBody } from './present-community-screen-body';
import { usePresentCommunityScreen } from './use-present-community-screen';

const PresentCommunityScreenComponent: NavigationScreen<'presentCommunity'> = ({ navigation }) => {
  const screenState = usePresentCommunityScreen({ navigation });

  return (
    <View style={{ flex: 1 }}>
      <PresentCommunityScreenBody {...screenState} />
    </View>
  );
};

export const PresentCommunityScreen: NavigationScreen<'presentCommunity'> = withErrorBoundary(
  PresentCommunityScreenComponent,
);
